// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import TextField from '@mui/material/TextField';
import { useDispatch, useSelector } from 'react-redux';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Checkbox, Divider, FormControlLabel, FormGroup, Grid, Card, IconButton, Tooltip, Typography, Button, CardActionArea, CardMedia } from '@mui/material';


// CUSTOM 
import { useNavigate } from 'react-router-dom';
import { getImageStore } from '../../../store/files';
import { formatDateToYmd } from '../../../commons/utils';
import { IDatosBasicos } from '../../../commons/interfaces';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';
import { CardActionImage } from '../../CardActionImage';






export const DatosBasicosDetalle = () => {

    
    // USE DISPATCH 
    const dispatch = useDispatch();

    // NAVIGATE 
    const navigate = useNavigate();


    // REDUX
    const { company }:any  = useSelector( (state:any) => state.company );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { economic_activity_list }:any = useSelector( (state:any) => state.economicactivity );
    const { type_documents_list, countries_list, sites_list }:IDatosBasicos  = useSelector( (state:any) => state.company );


    const [logoUrlComercial, setLogoUrlComercial] = useState('');
    const [logoUrlPostComercial, setLogoUrlPostComercial] = useState('');

    const [logoUrlRazonSocial, setLogoUrlRazonSocial] = useState('');
    const [logoUrlPostRazonSocial, setLogoUrlPostRazonSocial] = useState('');
    
    

    // USE EFFECT 
    useEffect(() => {

      if ( Object.keys(company).length > 0 ) {
        
          getLogoCompanyComercial(company.logo_company);
          getLogoPostCompanyComercial(company.logo_post_company);

          getLogoCompanyRazonSocial(company.logo_bn_rz_company);
          getLogoPostCompanyRazonSocial(company.logo_bn_rz_post_company);

      }
      

    }, [company]);


    useEffect(() => {
        
      if ( !company || Object.keys(company).length == 0 ) {
            navigate("/configuracion/compania");
      }

    }, [company]);


    useEffect(() => {
        
      if ( !company || Object.keys(company).length == 0 ) {
            navigate("/configuracion/compania");
      }

    }, []);



    // CONST FUNCTION 
    const getLogoCompanyComercial = async(imageName:string) => { 
      setLogoUrlComercial(imageName);
    }

    const getLogoPostCompanyComercial = async(imageName:string) => { 
      setLogoUrlPostComercial(imageName);
    }




    const getLogoCompanyRazonSocial = async(imageName:string) => { 
      setLogoUrlRazonSocial(imageName);
    }

    const getLogoPostCompanyRazonSocial = async(imageName:string) => { 
      setLogoUrlPostRazonSocial(imageName);
    }
    


  return (
    <div>
  
       {
           Object.keys(company).length > 0 &&

           <> 
              
              <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Datos Basicos
              </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                      
                      <TextField
                          fullWidth
                          name={company.typeDocument.type_document}
                          label={'Tipo Documento'}
                          defaultValue={company.typeDocument.type_document}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid> 
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        name={company.number_document}
                        label={'Numero Documento'}
                        defaultValue={company.number_document}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        name={company.tradename}
                        label={'Nombre Comercial'}
                        defaultValue={company.tradename}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        name={company.business_name}
                        label={'Razon Social'}
                        defaultValue={company.business_name}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        name={company.legal_representative}
                        label={'Representante Legal'}
                        defaultValue={company.legal_representative}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        name={company.email}
                        label={'Email'}
                        defaultValue={company.email}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        name={company.manager_in_charge}
                        label={'Gerente'}
                        defaultValue={company.manager_in_charge}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    {/* <Grid item xs={3}> 
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <CheckboxField  name={d_branch_offices.name} label={d_branch_offices.label}/>
                        <Tooltip title="Seleccione si la compañia cuenta con alguna sucursal en caso de no contar con sucursales omita el proceso.">
                          <IconButton>
                            <HelpOutlineOutlinedIcon color='primary'/>
                          </IconButton>
                        </Tooltip>
                        </div>
                    </Grid> */}
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={12}>
                        <TextField
                          fullWidth
                          name={company.economicActivity.categoria}
                          label={'Actividad Economica'}
                          defaultValue={company.economicActivity.categoria}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.country.name}
                          label={'Pais'}
                          defaultValue={company.country.name}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}> 
                        <TextField
                          fullWidth
                          name={company.departament.name}
                          label={'Departamento'}
                          defaultValue={company.departament.name}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}> 
                          <TextField
                          fullWidth
                            name={company.municipaly.name}
                            label={'Municipio'}
                            defaultValue={company.municipaly.name}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                    </Grid>
                    
                </Grid> 
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={3}>
                        <TextField
                          fullWidth
                          name={company.address_company}
                          label={'Direccion'}
                          defaultValue={company.address_company}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                          <TextField
                            fullWidth
                            name={company.workPlace.workplace}
                            label={'Sitio de Trabajo'}
                            defaultValue={company.workPlace.workplace}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                          fullWidth
                          name={company.landline}
                          label={'Telefono Fijo'}
                          defaultValue={company.landline}
                          InputProps={{
                            readOnly: true,
                          }}
                        /> 
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                          fullWidth
                          name={company.cell_phone}
                          label={'Celular'}
                          defaultValue={company.cell_phone}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                </Grid>
                <Divider sx={{ marginTop: 10 }}/>
                <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Forma De Pago
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.paymentFrequency.payment_frequency}
                          label={'Frecuencia Pago'}
                          defaultValue={company.paymentFrequency.payment_frequency}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.paymentMethod.payment_method}
                          label={'Metodo Pago'}
                          defaultValue={company.paymentMethod.payment_method}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.associatedBank.associated_bank}
                          label={'Banco Asociado'}
                          defaultValue={company.associatedBank.associated_bank}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.typeAccountBank.type_account_bank}
                          label={'Tipo Cuenta'}
                          defaultValue={company.typeAccountBank.type_account_bank}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.account_number}
                          label={'Numero Cuenta'}
                          defaultValue={company.account_number}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                </Grid>

                <Divider sx={{ marginTop: 10 }}/>
                <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Seguridad Social
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.sgsst.sgsst}
                          label={'Plataforma sst'}
                          defaultValue={company.sgsst.sgsst}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.arl.arl}
                          label={'Arl'}
                          defaultValue={ company.arl.arl }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                          fullWidth
                          name={company.constitution_date}
                          label={'Fecha Constitucion'}
                          defaultValue={ formatDateToYmd(company.constitution_date) }
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                    </Grid> 
                </Grid>
                <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={4} >
                          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                          <FormGroup>
                            <FormControlLabel control={<Checkbox checked={company.ley_1429_2010} />} label="ley 1429 2010" />
                          </FormGroup>
                          <Tooltip title='La presente ley tiene por objeto la formalización y la generación de empleo, con el fin de generar incentivos a la formalización en las etapas iniciales de la creación de empresas; de tal manera que aumenten los beneficios y disminuyan los costos de formalizarse.'>
                            <IconButton>
                              <HelpOutlineOutlinedIcon color='primary'/>
                            </IconButton>
                          </Tooltip>
                          </div>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                          <FormGroup>
                            <FormControlLabel control={<Checkbox checked={company.ley_590_2000} />} label="ley 590 2000" />
                          </FormGroup>
                          <Tooltip title='Promover el desarrollo integral de las micro, pequeñas y medianas empresas en consideración a sus aptitudes para la generación de empleo, el desarrollo regional, la integración entre sectores económicos, el aprovechamiento productivo de pequeños capitales y teniendo en cuenta la capacidad empresarial de los colombianos.'>
                            <IconButton>
                              <HelpOutlineOutlinedIcon color='primary'/>
                            </IconButton>
                          </Tooltip>
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                          <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <FormGroup>
                              <FormControlLabel control={<Checkbox checked={company.ley_1607_2012} />} label="ley 1607 2012" />
                            </FormGroup>
                            <Tooltip title='Declaración Voluntaria del Impuesto sobre la Renta. El impuesto sobre la renta y complementarios, a cargo de los contribuyentes no obligados a declarar, es el que resulte de sumar las retenciones en la fuente por todo concepto que deban aplicarse a los pagos o abonos en cuenta, según el caso, realizados al contribuyente durante el respectivo año o período gravable.'>
                              <IconButton>
                                <HelpOutlineOutlinedIcon color='primary'/>
                              </IconButton>
                            </Tooltip>
                          </div>
                    </Grid>
                </Grid>
              
                <Divider sx={{ marginTop: 10 }}/>
                <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Archivos
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Button>  RUT  </Button>
                        <Tooltip title="El RUT o Registro Único Tributario permite identificar, ubicar y clasificar a las personas y entidades, en su caso, que sean contribuyentes declarantes del impuesto de la renta y no contribuyentes declarantes de ingresos y patrimonio." >
                          <IconButton>
                              <HelpOutlineOutlinedIcon color='primary'/>
                            </IconButton>
                        </Tooltip>
                        <Divider/>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={100} label={'RUT'} hasIcon={true} /> 
                        </Card>
                    </Grid>  
                    <Grid item xs={4}>
                        <Button>  CÁMARA Y COMERCIO   </Button>
                        <Tooltip title="Es toda actividad económica organizada para la producción, transformación, circulación, administración o custodia de bienes, o para la prestación de servicios. La empresa puede ejecutar actividades de naturaleza industrial o productiva; comercial o de prestación de servicios." >
                          <IconButton>
                              <HelpOutlineOutlinedIcon color='primary'/>
                            </IconButton>
                        </Tooltip>
                        <Divider/>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                          <LinearProgressWithLabel percentage={100} label={'Camara y Comercio'} hasIcon={true} />
                        </Card>
                    </Grid>
                    <Grid item xs={4}>
                        <Button>  CERTIFICADO BANCARIO   </Button>
                        <Tooltip title="El Certificado Bancario es un título valor en moneda nacional o extranjera que es emitido al portador o nominativo por las empresas bancarias, en respaldo de la entrega de dinero en moneda extranjera, que garantiza una adecuada rentabilidad e inmediata liquidez." >
                          <IconButton>
                              <HelpOutlineOutlinedIcon color='primary'/>
                            </IconButton>
                        </Tooltip>
                        <Divider/>
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%', justifyContent: 'center', alignItems: 'center'  }}>
                          <LinearProgressWithLabel percentage={100} label={'Certificado Bancario'} hasIcon={true}/>
                        </Card>
                    </Grid>
                </Grid>

                <Divider sx={{ marginTop: 10 }}/>
                <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Logos Nombre Comercial
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6} >
                        <Divider/>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={company.logo_company} typeImage={'company'} />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <Button>  Sube Tu Logo Post Comercial</Button>
                        <Divider/>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={logoUrlPostComercial} typeImage={'company'} />
                        </div>
                    </Grid>
                </Grid>

                <Divider sx={{ marginTop: 10 }}/>
                <Typography variant="h5" component="h4" sx={{ margin: 5 }}>
                  Logos Razon Social
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button>Logo Razon Social</Button>
                        <Divider/>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={logoUrlRazonSocial} typeImage={'company'} />
                        </div>
                    </Grid>
                    <Grid item xs={6}>
                        <Button>Logo Post Razon Social</Button>
                        <Divider/>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <CardActionImage urlImage={logoUrlPostRazonSocial} typeImage={'company'} />
                        </div>
                    </Grid>
                </Grid>
                <Divider sx={{ marginTop: 7 }}/>
           
           </>
       }
       
    </div> 
  )
}


